/**
 * Sonneries synthétisées (WebAudio) : rien à charger, rien à héberger.
 * `sonnerieEntrante` : deux notes répétées ; `tonaliteRetour` : la tonalité
 * d'attente classique (1 s on / 4 s off) pendant que ça sonne chez l'autre.
 */
let ctx = null;
const contexte = () => {
  ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === 'suspended') ctx.resume().catch(() => {});
  return ctx;
};

const bip = (freq, duree, gain, quand) => {
  const c = contexte();
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = 'sine'; o.frequency.value = freq;
  g.gain.setValueAtTime(0, quand);
  g.gain.linearRampToValueAtTime(gain, quand + 0.02);
  g.gain.setValueAtTime(gain, quand + duree - 0.03);
  g.gain.linearRampToValueAtTime(0, quand + duree);
  o.connect(g); g.connect(c.destination);
  o.start(quand); o.stop(quand + duree);
};

const boucle = (motif, periodeMs) => {
  let actif = true;
  const jouer = () => { if (!actif) return; try { motif(contexte().currentTime); } catch { /* audio indisponible */ } };
  jouer();
  const id = setInterval(jouer, periodeMs);
  return () => { actif = false; clearInterval(id); };
};

export const sonnerieEntrante = () => boucle((t) => {
  bip(784, 0.35, 0.12, t); bip(988, 0.35, 0.12, t + 0.4);
  bip(784, 0.35, 0.12, t + 0.9); bip(988, 0.35, 0.12, t + 1.3);
}, 3000);

export const tonaliteRetour = () => boucle((t) => { bip(440, 1.0, 0.06, t); }, 5000);

export const bipFin = () => { try { bip(330, 0.25, 0.08, contexte().currentTime); } catch { /* ignore */ } };
